// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"C0ekE","title":"_2Qyt8","subTitle":"_19fkp"};